import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "sup-questionnaire-send-modal";

const keys = addTranslations(RESOURCE_NAME, {
    modal_title: {
        en: "Submit questionnaire",
        fr: "Soumettre le questionnaire",
    },
    modal_main_content: {
        en: "Are you sure you want to send this questionnaire? Once sent, the questionnaire will be closed and you will not be able to edit it anymore.",
        fr: "Voulez-vous envoyer ce questionnaire ? Une fois envoyé, le questionnaire sera clos et vous ne pourrez plus l'éditer.",
    },
    modal_not_answered_questions_warning: {
        en: "One question has not been answered yet.",
        fr: "Une question n'a pas été répondues.",
    },
    modal_not_answered_questions_warning_other: {
        en: "There are {{count}} questions that have not been answered yet.",
        fr: "Il y a {{count}} questions qui n'ont pas été répondues.",
    },
    modal_not_validated_questions_warning: {
        en: "One question has not been validated yet.",
        fr: "Une question n'a pas été validée.",
    },
    modal_not_validated_questions_warning_other: {
        en: "There are {{count}} questions that have not been validated yet.",
        fr: "Il y a {{count}} questions qui n'ont pas été validées.",
    },
    modal_warning_title: {
        en: "Warning",
        fr: "Attention",
    },
    modal_missing_proof_questions_warning: {
        en: "One question is missing required documents.",
        fr: "Une question manque des documents requis.",
    },
    modal_missing_proof_questions_warning_other: {
        en: "{{count}} questions are missing required documents.",
        fr: "{{count}} questions manquent des documents requis.",
    },
    modal_trigger_button: {
        en: "Submit questionnaire",
        fr: "Soumettre le questionnaire",
    },
    modal_cancel_button: {
        en: "Cancel",
        fr: "Annuler",
    },
    modal_confirm_button: {
        en: "Submit",
        fr: "Soumettre",
    },
});

export function useSupplierQuestionnaireSendModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
